import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import http from "../../services/http/http";
import toast from "react-hot-toast";

// const apiUrl2 = `https://phpstack-737101-2469488.cloudwaysapps.com/mu-online`;
const apiUrl2 = "https://phpstack-737101-2642882.cloudwaysapps.com/web";
const apiUrl33 = `http://localhost:3001/web`;
//const apiUrl = `http://5.180.181.26:3009/web`;
const apiUrl = `https://mu-beginning.co.il/web`;

export const getPlayerInWeb = createAsyncThunk(
  "getPlayerInWeb",
  async ({ playername }) => {
    const response = await http.get(`${apiUrl}/user/${playername}`);

    return response.data;
  },
);

export const getGuildInWeb = createAsyncThunk(
  "getGuildInWeb",
  async ({ guildname }) => {
    const response = await http.get(`${apiUrl}/guild/${guildname}`);

    return response.data;
  },
);

// export const getPlayerInWeb = createAsyncThunk("getPlayerInWeb", async () => {
//   const response = await http.get(`${apiUrl}/user/:playername`);
//   return response.data;
// });

export const getTopGuilds = createAsyncThunk("getGuilds", async () => {
  const response = await http.get(`${apiUrl}/topGuilds`);
  return response.data;
});

export const getOwners = createAsyncThunk("getOwners", async () => {
  const response = await http.get(`${apiUrl}/owners`);
  return response.data;
});

export const getTop10Players = createAsyncThunk("getTop10Players", async () => {
  const response = await http.get(`${apiUrl}/top10Players`);
  return response.data;
});

export const getTop100Players = createAsyncThunk(
  "getTop100Players",
  async () => {
    const response = await http.get(`${apiUrl}/top100`);
    return response.data;
  },
);

export const searchPlayers = createAsyncThunk("searchPlayers", async (q) => {
  const response = await http.get(`${apiUrl}/searchPlayers`, {
    params: { q },
  });
  return response.data;
});

export const getCastleSiegeWinners = createAsyncThunk(
  "getCastleSiegeWinners",
  async () => {
    const response = await http.get(`${apiUrl}/castleSiegeWinners`);
    return response.data;
  },
);

export const getCastleRegisteredGuilds = createAsyncThunk(
  "getCastleRegisteredGuilds",
  async () => {
    const response = await http.get(`${apiUrl}/castleRegisteredGuilds`);
    return response.data;
  },
);

export const getPlayersOnline = createAsyncThunk(
  "getPlayersOnline",
  async () => {
    const response = await http.get(`${apiUrl}/playersOnline`);
    return response.data;
  },
);

export const getPlayerStats = createAsyncThunk("getPlayerStats", async () => {
  const response = await http.get(`${apiUrl}/playerStats`);
  return response.data;
});

export const getEventTimes = createAsyncThunk(
  "getEventTimes",
  async (limit) => {
    const q = limit ? `?limit=${limit}` : "";
    const response = await http.get(`${apiUrl}/eventTimes${q}`);
    return response.data;
  },
);

const initialState = {
  top5Guild: {
    data: [],
    status: "",
  },
  owners: {
    data: [],
    status: "",
  },
  top10Players: {
    data: [],
    status: "",
  },
  top100Players: {
    data: [],
    status: "",
  },
  castleSiegeWinners: {
    data: [],
    status: "",
  },

  castleRegisteredGuilds: {
    data: [],
    status: "",
  },

  playersOnline: {
    data: { playersOnline: null },
    status: "",
  },

  playerStats: {
    data: null,
    status: "",
  },

  eventTimes: {
    data: [],
    status: "",
  },

  PlayerInfo: {
    data: [],
    status: "",
  },

  Guild: {
    data: [],
    status: "",
  },
};

const connectApi = createSlice({
  name: "MuOnlineApi",
  initialState,
  extraReducers: {
    [getTopGuilds.fulfilled]: (state, { meta, payload }) => {
      //   state.status = meta.requestStatus;
      state.top5Guild.data = payload;
    },

    [getTopGuilds.rejected]: (state, { meta, payload }) => {
      state.top5Guild.status = meta.requestStatus;
      // state.guildsState = payload;
    },

    [getOwners.fulfilled]: (state, { payload }) => {
      //   state.status = meta.requestStatus;
      state.owners.data = payload;
    },

    [getOwners.rejected]: (state, { meta }) => {
      state.owners.status = meta.requestStatus;
    },

    [getTop10Players.fulfilled]: (state, { payload }) => {
      state.top10Players.data = payload;
    },

    [getTop10Players.rejected]: (state, { meta }) => {
      state.top10Players.status = meta.requestStatus;
    },

    [getTop100Players.fulfilled]: (state, { payload }) => {
      state.top100Players.data = payload;
    },

    [getTop100Players.rejected]: (state, { meta }) => {
      state.top100Players.status = meta.requestStatus;
    },

    [getCastleSiegeWinners.fulfilled]: (state, { payload }) => {
      state.castleSiegeWinners.data = payload;
    },

    [getCastleSiegeWinners.rejected]: (state, { meta }) => {
      state.castleSiegeWinners.status = meta.requestStatus;
    },

    [getCastleRegisteredGuilds.fulfilled]: (state, { payload }) => {
      state.castleRegisteredGuilds.data = payload;
    },

    [getCastleRegisteredGuilds.rejected]: (state, { meta }) => {
      state.castleRegisteredGuilds.status = meta.requestStatus;
    },

    [getPlayersOnline.fulfilled]: (state, { payload }) => {
      state.playersOnline.data = payload;
      state.playersOnline.status = "fulfilled";
    },
    [getPlayersOnline.rejected]: (state, { meta }) => {
      state.playersOnline.status = meta.requestStatus;
    },

    [getPlayerStats.fulfilled]: (state, { payload }) => {
      state.playerStats.data = payload;
      state.playerStats.status = "fulfilled";
    },
    [getPlayerStats.rejected]: (state, { meta }) => {
      state.playerStats.status = meta.requestStatus;
    },

    [getEventTimes.fulfilled]: (state, { payload }) => {
      state.eventTimes.data = payload?.events || [];
      state.eventTimes.status = "fulfilled";
    },
    [getEventTimes.rejected]: (state, { meta }) => {
      state.eventTimes.status = meta.requestStatus;
    },

    [getPlayerInWeb.pending]: (state) => {
      state.PlayerInfo.status = "pending";
      state.PlayerInfo.data = [];
    },
    [getPlayerInWeb.fulfilled]: (state, { payload }) => {
      state.PlayerInfo.data = payload;
      state.PlayerInfo.status = "fulfilled";
    },

    [getPlayerInWeb.rejected]: (state, { meta }) => {
      state.PlayerInfo.status = meta.requestStatus;
    },

    [getGuildInWeb.fulfilled]: (state, { payload }) => {
      state.Guild.data = payload;
    },
  },
});

export default connectApi.reducer;
